import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { PrimaryHeader } from "../../components/header/primary";
import { AttendanceGroupNavigator } from "./components/navigator";

import { useStyleContext } from "../../context/StyleContext";

export const UserAttendanceGroupPage: FC = () => {
  const { stylePage } = useStyleContext();
  return (
    <div
      className={"h-full w-full overflow-y-auto bg-neutral-100"}
      style={stylePage}
    >
      <PrimaryHeader
        breadcrumbItems={[
          {
            label: "Asistencia",
            active: true,
          },
        ]}
        title={"Asistencia"}
      />
      <div
        className={
          "w-full flex flex-col lg:flex-row border-t-2 border-neutral-200"
        }
      >
        <div className={"w-full md:w-fit p-2 md:p-3 lg:py-5"}>
          <div
            className={
              "lg:bg-white lg:rounded-xl lg:overflow-hidden lg:border lg:border-neutral-300"
            }
          >
            <AttendanceGroupNavigator />
          </div>
        </div>
        <div className={"w-full overflow-y-auto p-2 md:p-3 lg:py-3 lg:px-5"}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
